import { gql } from '@apollo/client';

export const FRAGMENT_ACCESS_GROUP = gql`
    fragment accessGroup on AccessGroup {
        id
        name
        description
        isInheritable
        owner {
            companyAlias
            facilityAlias
        }
        parent {
            id
        }
    }
`;
